import { I9FormStatus } from '@/features/employee_record/application/domain/entities/enums/i9Form-status.enum';
import { I9Record, Section1Data } from '../../../application/domain/entities/EmployeeRecord';
import { EmployeeRecordResponseDto, Section1DataDto } from '../dto/res/EmployeeRecordResponseDto';

export class EmployeeRecordMapper {
  static toDomain(dto: EmployeeRecordResponseDto): I9Record {
    return {
      i9FormId: dto.i9FormId,
      accountId: dto.accountId,
      status: this.mapStatus(dto.status),
      isAmendmentInProgress: dto.isAmendmentInProgress,
      location: dto.location,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
      section1: dto.section1 ? this.mapSection1ToDomain(dto.section1) : null,
      hireDate: dto.firstDayOfEmployement ? new Date(dto.firstDayOfEmployement) : '-',
      remoteI9Flag: dto.remoteI9Flag,
      remoteI9Status: dto.remoteI9Status,
      referenceNumber: dto.referenceNumber,
      awaitingInPersonReview: dto.awaitingInPersonReview === true,
    };
  }

  private static mapStatus(status: string): I9FormStatus {
    switch (status) {
      case 'section1Pending':
        return I9FormStatus.SECTION1_PENDING;
      case 'section1Completed':
        return I9FormStatus.SECTION1_COMPLETED;
      case 'section2Completed':
        return I9FormStatus.SECTION2_COMPLETED;
      case 'digitized':
        return I9FormStatus.DIGITIZED;
      case 'remediated':
        return I9FormStatus.REMEDIATED;
      default:
        throw new Error(`Unknown status: ${status}`);
    }
  }
  

  private static mapSection1ToDomain(dto: Section1DataDto): Section1Data {
    return {
      section1Id: dto.section1Id,
      firstName: dto.firstName,
      lastName: dto.lastName,
      middleName: dto.middleName,
      otherName: dto.otherName,
      address: dto.address,
      appartmentNumber: dto.appartmentNumber,
      zipCode: dto.zipCode,
      city: dto.city,
      stateId: dto.stateId,
      locationId: dto.locationId,
      locationName: dto.locationName,
      // `new Date(null)` is the epoch, not "unknown" — a digitized I-9 with an unreadable date of
      // birth would have silently displayed 01/01/1970 as though it were the employee's real DOB.
      dateOfBirth: dto.dateOfBirth ? new Date(dto.dateOfBirth) : null,
      ssn: dto.ssn,
      phoneNumber: dto.phoneNumber,
      email: dto.email,
      doNotHaveSsn: dto.doNotHaveSsn,
      status: dto.status,
      citizenshipStatus: dto.citizenshipStatus
    };
  }
}
